import React__default from 'react';
import _s, { css } from 'styled-components';
import Box from './Box.js';
import Typography from './Typography.js';
import './useTheme.js';

const styled = typeof _s === "object" && "default" in _s ? _s.default : _s;
var LinkButtonVariants;
(function (LinkButtonVariants) {
  LinkButtonVariants["default"] = "label-1";
  LinkButtonVariants["medium"] = "label-3";
  LinkButtonVariants["small"] = "caption-1";
})(LinkButtonVariants || (LinkButtonVariants = {}));
const LinkButton = ({
  href = '#',
  children,
  onPress,
  openNewWindow,
  testID,
  color = 'tertiary',
  variant = 'default',
  download,
  disabled
}) => {
  return /*#__PURE__*/React__default.createElement(Container, {
    "data-testid": testID,
    href: !disabled ? href : undefined,
    onClick: !disabled ? onPress : () => {},
    "$color": color,
    "$disabled": disabled,
    rel: openNewWindow ? 'noopener noreferrer' : undefined,
    target: openNewWindow ? '_blank' : '_self',
    download: download !== null && download !== void 0 ? download : undefined
  }, /*#__PURE__*/React__default.createElement(Box, {
    alignItems: "center",
    justifyContent: "center"
  }, /*#__PURE__*/React__default.createElement(Typography, {
    center: true,
    color: color,
    variant: LinkButtonVariants[variant]
  }, children)));
};
const Container = styled.a`
  display: block;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  text-decoration: none;

  &:hover {
    opacity: 0.75;
    text-decoration: underline;
    text-decoration-color: ${({
  theme,
  $color
}) => theme.colors[$color]};
  }

  ${({
  $disabled
}) => $disabled && css(["cursor:not-allowed;opacity:0.5;&:hover{opacity:0.5;text-decoration:none;}"])}
`;

export { LinkButton as default };
//# sourceMappingURL=LinkButton.js.map
